define('services/InvoiceCorrections',['require','utils','arrayutils'],function (require) {
    'use strict';
    var utils = require('utils');
    var arrayUtils = require('arrayutils');
    var InvoiceCorrections = function() {
        this._nightInValidHandler = this._nightInValid.bind(this);
    };
    var proto = InvoiceCorrections.prototype;

    /**
     * This method makes the our data match the invoice.
     * It will divide the totals into the nights as evenly as possible and add pennies on as necessary to match the correct totals. 
     * Corrections are left null where they are not needed TODO: test
     * Note that if the hotel simply charged us too much, no correction is needed; we pay them what we are supposed to pay them, i.e. what's in our system already
     * Note: to reverse a correction, make a new correction
     * Refund Bit TODO: tests
     *      if true, this will do an update move applied funds from the vacation to the member's vsa. Do this when the hotel mischarges us and it's more than a few pennies.
     *      if false, this will apply a correction. Do this when either the hotel has mischarged us a few pennies or when we mischarge the member due to a missed fee/tax
     * @param {decimal} roomrate The correct total roomrate
     * @param {decimal} tax The correct total tax
     * @param {decimal} fees The correct total fees
     * @returns {correction}
     */
    proto.generateCorrectionNights = function (roomrate, fee, tax, nights) {
        var nightcount = nights.length;
        var roomRateParts = this._getNightlyRateAndRemainder(roomrate, nightcount);
        var feeParts = this._getNightlyRateAndRemainder(fee, nightcount);
        var taxParts = this._getNightlyRateAndRemainder(tax, nightcount);
        for (var i = nightcount - 1; i >= 0; i--) {
            var night = nights[i];
            night.RoomRate = this._setRate(roomRateParts);
            night.HotelFees = this._setRate(feeParts);
            night.HotelTaxFees = this._setRate(taxParts);
        }
        return nights;
    };

    /**
     * if what we've charged them is greater than the invoice by 10 cents, set to refund
     * @param {object} invoice 
     * @returns {bool} 
     */
    proto.shouldRefund = function (invoice) {
        var ourTotal = invoice.RoomRateTotal + invoice.HotelFeesTotal + invoice.HotelTaxFeesTotal;
        var invoiceTotal = invoice.InvoiceRoomRateTotal + invoice.InvoiceFeesTotal + invoice.InvoiceTaxTotal;
        return ourTotal - invoiceTotal > 0.10;
    };

    /**
     * if any nights aren't rounded to 2 decimals or the totals don't add up exactly (manual bookings have to divide out evenly and elites don't round out to 2 decimal places)
     * @returns {bool} 
     */
    proto.needsCorrections = function(roomrate, fee, tax, nights) {
        return nights.some(this._nightInValidHandler) ||
            roomrate !== utils.roundNumber(arrayUtils.sum(nights, 'Rate'), 2) ||
            tax !== utils.roundNumber(arrayUtils.sum(nights, 'Tax'), 2) ||
            fee !== utils.roundNumber(arrayUtils.sum(nights, 'Fee'), 2);
    };

    /**
     * verifies the night is rounded to 2 decimal places
     * @param {Night} n 
     * @returns {bool} 
     */
    proto._nightInValid = function (n) {
        var total = n.Rate + n.Tax + n.Fee;
        return utils.roundNumber(total, 2).toString() !== total.toString();
    };

    /**
     * get the rounded, average nightly rate and the number of remaining pennies we need to disperse for division remainders
     * @param {decimal} totalRate 
     * @param {int} nightCount 
     * @returns {object} 
     */
    proto._getNightlyRateAndRemainder = function(totalRate, nightCount) {
        var nightly = utils.roundNumber(totalRate / nightCount, 2);
        var remainder = utils.roundNumber(totalRate - (nightly * nightCount), 2); //need to round this since js us poor about handling floats--this number should be 2 decimals in reality anyway
        var remainderPennies = remainder / 0.01; //number of pennies should NOT be more than number of nights, so disperse them backward through the nights...
        return {
            nightly: nightly,
            remainingPennies: remainderPennies
        };
    };

    /**
     * Manages the remainder while setting the rate for the given night
     * @param {NightlyRateAndRemainder} rateParts 
     * @returns {decimal} 
     */
    proto._setRate = function (rateParts) {
        if (rateParts.remainingPennies === 0) {
            return rateParts.nightly;
        }
        var remainderDiff = rateParts.remainingPennies < 0 ? -1 : 1; //determine if we need to add or subtract
        rateParts.remainingPennies += -remainderDiff; //update the remainder
        return utils.roundNumber(rateParts.nightly + (remainderDiff / 100), 2); //return the adjusted rate to include part of the remainder
    };

    return InvoiceCorrections;
});
